import { gql } from "apollo-boost"

export const UPDATE_ASSISTANCE = gql`
  mutation UpdateAssistance(
    $id: ID!
    $hasAssist: Boolean!
  ) {
    UpdateAssistance(
      id: $id,
      hasAssist: $hasAssist
    ) {
      id
      hasAssist
    }
  }
`
